import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button
} from 'reactstrap';

import FormBuilder from './forms/formBuilder';
import { required, emailAddress } from './forms/validation'
import { connect } from "react-redux";
import { formValueSelector, change } from "redux-form"; // ES6

import { API_ENDPOINT } from '../constants'


import backIcon from '../assets/svg/back-icon.svg'
import QRCode from "react-qr-code";
import Isvg from "react-inlinesvg";
import bankidIcon from '../assets/svg/bankid.svg';
import { Player, Controls } from "@lottiefiles/react-lottie-player";


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
/**
* BankID modal for login
* @author   Milan Stanojevic
*/
class BankIdModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            changeQrCode: true,
            qrCodeTimeExpiration: 1
        }
    }

    componentDidMount() {
        window.addEventListener('message', (e) => {
            if (e && e.data && e.data?.indexOf('signed') != -1) {
                let id;
                if (e.data.indexOf('=') != -1) {
                    let eDataSplit = e.data.split('=');
                    if (eDataSplit && eDataSplit[1]) {
                        id = eDataSplit[1];
                    }

                }
                this.props.toggle(id);

            }
        }, false)

        this.interval = setInterval(() => {
            if (this.state.qrCodeExpired) {
                return
            }
            this.checkBankIdSign()
            const imageElement = document.getElementById('qr-image');
            if (imageElement && this.state.changeQrCode) {
                this.setState({
                    changeQrCode: false
                }, () => {
                    this.changeQrCod()
                })
            }
        }, 2000);

        window.addEventListener("keydown", this.onKeyDown, { capture: true }); // capture gets it early
    }

    onKeyDown = (e) => {
        // ignore when typing in inputs/editors
        // const tgt = e.target;
        // if (tgt && (tgt.closest('input, textarea, [contenteditable="true"]'))) return;

        // detect Space
        if (e.code === "Space" || e.key === " ") {
            if (e.repeat) return;
            if (this.componentUnmounted) return;
            if (this.state.qrCodeTimeExpiration && (300 - 2 * this.state.qrCodeTimeExpiration) <= 30) {


                if (e.code === 'Space' || e.key === ' ' || e.keyCode === 32) {
                    e.preventDefault();

                    this.setState({
                        qrCodeExpired: false,
                        qrCodeTimeExpiration: 1
                    }, () => {
                        clearInterval(this.qrCodeInterval);
                        this.props.changeQRCode()
                        if (this.qrCodeButton) {
                            this.qrCodeButton.focus({ preventScroll: true })
                        }

                    })
                }

            }
        }
    }

    changeQrCod = () => {
        if (this.qrCodeInterval) {
            clearInterval(this.qrCodeInterval)
        }

        this.setState({
            qrCodePendingSign: false,
            qrCodeExpired: false
        })
        const qrCodeLink = this.props.qrCodeLink;
        const imageElement = document.getElementById('qr-image');
        let t = 0;

        this.qrCodeInterval = setInterval(() => {
            // QR code doesn't work after repeating 14 times so that is the limit for bankid v5 for now
            if (t === 14) {
                clearInterval(this.qrCodeInterval);
                // this.checkBankIdSign();
                this.props.changeQRCode()
                t = 0;
            }

            imageElement.setAttribute('src', qrCodeLink + '&t=' + t);
            t++;
            this.setState({
                qrCodeTimeExpiration: this.state.qrCodeTimeExpiration + 1
            }, () => {
                if (this.state.qrCodeTimeExpiration === 150) {
                    clearInterval(this.qrCodeInterval);
                    this.setState({
                        qrCodeExpired: true
                    })
                }
            })
        }, 2000);
    }

    checkBankIdSign = () => {
        fetch(API_ENDPOINT + '/users/bankid/v5/check/sign', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({ key: this.props.isOpen && this.props.isOpen.key, alias: this.props.alias ? this.props.alias : '' })
        }).then(res => res.json()).then((result) => {
            if (result && result.pending) {
                this.setState({
                    qrCodePendingSign: true,
                    loading: true
                }, () => {
                    if (this.qrCodeInterval) {
                        clearInterval(this.qrCodeInterval)
                    }

                })
            }
            if (result && result.failed && !this.state.qrCodeTryAgain) {
                this.setState({
                    qrCodeExpired: true,
                }, () => {
                    if (this.qrCodeInterval) {
                        clearInterval(this.qrCodeInterval)
                    }
                })
            }
            if (result && result.status && result.status === 'Finished') {
                this.props.toggle(this.props.isOpen && this.props.isOpen.key)
                clearInterval(this.interval)
                clearInterval(this.qrCodeInterval)
            }
        })
    }

    componentWillUnmount() {
        this.componentUnmounted = true;
        if (this.interval) {
            clearInterval(this.interval)
        }

        if (this.qrCodeInterval) {
            clearInterval(this.qrCodeInterval)
        }
        window.removeEventListener("keydown", this.onKeyDown);
    }

    componentDidUpdate(prevProps) {
        if (this.props.qrCodeLink !== prevProps.qrCodeLink) {
            this.setState({
                changeQrCode: true,
                qrCodePendingSign: false,
                qrCodeTryAgain: false
            })
        }
    }


    minutesLeft = (time) => {
        const timeLeft = 300 - 2 * time
        if (timeLeft > 50) {
            return Math.ceil(timeLeft / 60) + " " + 'minutes left'.translate(this.props.lang)
        }
        if (timeLeft <= 10) {
            return '10 seconds left'.translate(this.props.lang)
        }
        if (timeLeft <= 20) {
            return '20 seconds left'.translate(this.props.lang)
        }
        if (timeLeft <= 30) {
            return '30 seconds left'.translate(this.props.lang)
        }
        if (timeLeft <= 40) {
            return '40 seconds left'.translate(this.props.lang)
        }
        if (timeLeft <= 50) {
            return '50 seconds left'.translate(this.props.lang)
        }
    }

    percentageLeft = (current, amount) => {
        // going from 100% do 0%
        return Math.floor(((amount - current) / amount) * 100)
    }

    generateDropDownText = () => {
        return <div style={{ width: 300 }}>
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', cursor: 'pointer' }} onClick={() => {
                    this.setState({
                        showHelpDropDown: !this.state.showHelpDropDown,
                        // showReaderDropDown: false
                    }, () => {
                        // this.updateMode()
                    })
                }}>
                    <h5>{"Help with scanning the QR code".translate(this.props.lang)}</h5>
                    <div style={{ transform: `rotate(90deg)`, fontSize: 24 }}>{">"}</div>
                </div>
                {
                    this.state.showHelpDropDown ?
                        <div style={{ textAlign: 'left' }}>
                            <ol>
                                <li>{'Open the BankID app'.translate(this.props.lang)}</li>
                                <li>{"Press the button 'Scan QR code'".translate(this.props.lang)}</li>
                                <li>{"Aim the phone's camera towards the QR code".translate(this.props.lang)}</li>
                                <li>{'Follow the instructions in the app'.translate(this.props.lang)}</li>
                            </ol>
                            <p style={{ padding: 10 }}>
                                {"The QR code is shown for 5 minutes before the identification is cancelled for security reasons. You can try again if that happens.".translate(this.props.lang)}
                            </p>
                            <p style={{ padding: 10 }}>
                                {"Make sure the entire QR code fits on the screen, otherwise it can't be scanned.".translate(this.props.lang)}

                            </p>
                        </div>
                        :
                        null
                }
            </div>
            <hr />
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', cursor: 'pointer' }} onClick={() => {
                    this.setState({
                        showReaderDropDown: !this.state.showReaderDropDown,
                        // showHelpDropDown: false
                    }, () => {
                        // this.updateMode()
                    })
                }}>
                    <h5>{"If you use a screen reader".translate(this.props.lang)}</h5>
                    <div style={{ transform: `rotate(90deg)`, fontSize: 24 }}>{">"}</div>
                </div>
                {
                    this.state.showReaderDropDown ?
                        <div style={{ textAlign: 'left' }}>
                            <p style={{ padding: 10 }}>
                                {"The most common issue is that the entire QR code doesn't fit on the screen. Please try to:".translate(this.props.lang)}

                            </p>
                            <ul>
                                <li>{'Ensure that the screen is switched on and Screen Curtain or similar functions are switched off.'.translate(this.props.lang)}</li>
                                <li>
                                    <div>
                                        {'Zoom out in your browser by using short command:'.translate(this.props.lang)}
                                    </div>
                                    <ul>
                                        <li>{'Windows: Ctrl+0'.translate(this.props.lang)}</li>
                                        <li>{'Mac: Cmd+0'.translate(this.props.lang)}</li>
                                    </ul>
                                </li>
                                <li>{'Zoom out with magnification tools such as ZoomText.'.translate(this.props.lang)}</li>
                                <li>
                                    <div>
                                        {'Ensure the browser window is maximized by:'.translate(this.props.lang)}
                                    </div>
                                    <ul>
                                        <li>{'Clicking the QR code above'.translate(this.props.lang)}</li>
                                        <li>
                                            <div>
                                                {'Using the short commands:'.translate(this.props.lang)}
                                            </div>
                                            <ul>
                                                <li>{'Windows: Ctrl+Arrow up'.translate(this.props.lang)}</li>
                                                <li>{'Mac: Ctrl+F'.translate(this.props.lang)}</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li>{'Hold your phone in portrait mode 40cm from the screen when you scan the QR code.'.translate(this.props.lang)}</li>
                            </ul>
                        </div>
                        :
                        null
                }
            </div>
            <hr />
        </div>
    }

    render() {
        return (

            <Modal isOpen={this.props.isOpen} centered>
                <ModalHeader toggle={this.props.toggle} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={this.props.closeModal ? this.props.closeModal : this.props.toggle}>&times;</button>}>
                    {'BankID'.translate(this.props.lang)}
                </ModalHeader>
                <ModalBody className="bankid-modal">

                    {/* <div className='bank-id-checkout'>
                        <div  >
                            <img id='qr-image' src={this.props.qrCodeLink} style={{ height: 'auto', maxWidth: 200, width: 200 }} />

                        </div>
                        <p>{"Scan QR code if bankid app doesn't shows up".translate(this.props.lang)}</p>
                        <a href={this.props.redirect_url} className='btn btn-primary'>{"Open BankID on this device".translate(this.props.lang)}</a>
                    </div>
                    <p className="error-message">{this.state.error}</p> */}

                    <div className="bank-id-sign" ref={(node) => { this.wrapRef = node }}>


                        {(this.props.loading || this.state.loading) && (!this.props.qrCodeLink || this.state.qrCodePendingSign) && !this.state.qrCodeExpired ?

                            <div>
                                <Player
                                    autoplay={true}
                                    loop={true}
                                    renderer={'svg'}
                                    src="/lf30_editor_l5cxzdyf.json"
                                    style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "64px" : "128px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "64px" : "128px" }}
                                ></Player>

                                {
                                    this.state.qrCodePendingSign ?
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                            <p>{"Enter your security code in the BankID app and select Identify.".translate(this.props.lang)}</p>

                                            {
                                                this.generateDropDownText()
                                            }
                                        </div>
                                        :
                                        null
                                }
                            </div>
                            :
                            null
                        }

                        {
                            this.state.isFullScreen && (document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement || (this.wrapRef && this.wrapRef.classList.contains('fs-sim-sign'))) && !this.state.qrCodeExpired && !this.state.qrCodePendingSign ?
                                <div style={{ height: 50 }}>
                                    <Button className='exit-button-full-screen' onClick={async () => {
                                        const el = this.wrapRef;

                                        const exitFS = async () => {
                                            try {
                                                await (document.exitFullscreen?.() ||
                                                    document.webkitExitFullscreen?.() ||
                                                    document.msExitFullscreen?.());
                                            } catch (e) { console.error(e); }
                                        };

                                        // iOS Safari cannot fullscreen arbitrary elements; fallback to CSS
                                        const isIOS = /iP(hone|ad|od)/.test(navigator.userAgent);

                                        if (!isIOS) {
                                            await exitFS();
                                        } else {
                                            // fallback toggle
                                            const on = !el.classList.contains('fs-sim-sign');
                                            el.classList.toggle('fs-sim-sign', on);
                                            document.documentElement.classList.toggle('no-scroll', on);
                                        }

                                        this.setState({
                                            isFullScreen: false
                                        })
                                        // this.updateMode()
                                    }}>
                                        <div>
                                            {'Exit full screen'.translate(this.props.lang)}
                                        </div>
                                        <div style={{ height: 30, width: 30, borderRadius: '50%', color: 'white', background: '#568AC8', display: 'flex', justifyContent: 'center', alignItems: 'center', marginLeft: 20 }}>X</div>
                                    </Button>
                                </div>
                                :
                                null
                        }


                        {this.props.qrCodeLink && !this.state.qrCodeExpired && !this.state.qrCodePendingSign ?

                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                <p id="above-qr-image-p">
                                    {"Please start the BankID app and scan the QR code".translate(this.props.lang)}
                                </p>
                                <div id={'qr-image-div'} ref={(node) => this.qrImage = node} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <button ref={(node) => this.qrCodeButton = node} onClick={async () => {
                                        const el = this.wrapRef;
                                        if (!el) return;

                                        const isFS = () =>
                                            document.fullscreenElement ||
                                            document.webkitFullscreenElement ||
                                            document.msFullscreenElement;

                                        const canFS = !!(
                                            el.requestFullscreen ||
                                            el.webkitRequestFullscreen ||
                                            el.msRequestFullscreen
                                        );

                                        const enterFS = async () => {
                                            try {
                                                await (el.requestFullscreen?.() ||
                                                    el.webkitRequestFullscreen?.() ||
                                                    el.msRequestFullscreen?.());
                                            } catch (e) { console.error(e); }
                                        };

                                        const exitFS = async () => {
                                            try {
                                                await (document.exitFullscreen?.() ||
                                                    document.webkitExitFullscreen?.() ||
                                                    document.msExitFullscreen?.());
                                            } catch (e) { console.error(e); }
                                        };

                                        // iOS Safari cannot fullscreen arbitrary elements; fallback to CSS
                                        const isIOS = /iP(hone|ad|od)/.test(navigator.userAgent);

                                        if (canFS && !isIOS) {
                                            if (isFS()) await exitFS();
                                            else await enterFS();
                                        } else {
                                            // fallback toggle
                                            const on = !el.classList.contains('fs-sim-sign');
                                            el.classList.toggle('fs-sim-sign', on);
                                            document.documentElement.classList.toggle('no-scroll', on);
                                        }

                                        // this.updateMode()
                                        this.setState({
                                            isFullScreen: !this.state.isFullScreen
                                        })
                                    }} aria-label='QR code, scan with BankID app, hold your phone in portrait mode 40cm from the screen. Click to enter full screen' >
                                        <img id='qr-image' onLoad={() => {
                                            this.setState({
                                                imageLoaded: true
                                            })
                                        }} alt='QR code. Click for fullscreen' src={this.props.qrCodeLink} style={{ height: 'auto', maxWidth: 185, width: 185 }} />

                                    </button>

                                    {
                                        this.state.qrCodeTimeExpiration ?
                                            <div style={{ marginBottom: 5 }}>
                                                <div style={{ position: 'relative', width: 150, height: 12, overflow: 'hidden', alignItems: 'center', marginBottom: 10 }}>
                                                    <div style={{ height: '100%', background: 'rgb(24 62 79 / var(--tw-bg-opacity, 1))', transition: 'width .35s ease', width: `${this.percentageLeft(this.state.qrCodeTimeExpiration, 150)}%` }} />
                                                </div>
                                                <div aria-live style={{ display: 'flex', background: 'white', alignItems: 'center', justifyContent: 'center', font: '12px', color: 'black' }}>{this.minutesLeft(this.state.qrCodeTimeExpiration)}</div>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.state.qrCodeTimeExpiration && (300 - 2 * this.state.qrCodeTimeExpiration) <= 30 ?
                                            <Button style={{ backgroundColor: '#568AC8', marginBottom: 20 }} onClick={() => {
                                                this.setState({
                                                    qrCodeExpired: false,
                                                    qrCodePendingSign: false,
                                                    qrCodeTimeExpiration: 1,
                                                }, () => {
                                                    this.props.changeQRCode()
                                                })

                                            }}>{'Extend time'.translate(this.props.lang)}</Button>
                                            :
                                            null
                                    }

                                </div>
                                <a href={this.props.redirectUrl} style={{ marginBottom: 20 }} className='btn btn-primary'>{"Open BankID on this device".translate(this.props.lang)}</a>

                                {
                                    this.generateDropDownText()
                                }


                            </div>
                            :
                            this.state.qrCodeExpired ?
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                    <p style={{ color: 'red' }}>{'Due to inactivity, the session has expired'.translate(this.props.lang)}</p>
                                    <Button style={{ backgroundColor: '#568AC8', marginBottom: 20 }} onClick={() => {
                                        this.setState({
                                            qrCodeExpired: false,
                                            qrCodeTryAgain: true,
                                            qrCodeTimeExpiration: 1,
                                        }, () => {
                                            this.props.changeQRCode()
                                        })
                                    }}>{'Try again'.translate(this.props.lang)}</Button>

                                </div>
                                :
                                null
                        }

                    </div>

                </ModalBody>
            </Modal>

        )
    }
}

const selector2 = formValueSelector("form");


export default connect(
    (state) => {
        return {
            sex: selector2(state, 'userData.sex')
        };
    },
    {
        changeSex: (value) => change("form", "userData.sex", value),

    }
)(BankIdModal);